<template>
  <div class="dashboard-container">
    <component v-bind:is="currentRole"> </component>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import EditorDashboard from './editor/index';

  export default {
    name: 'dashboard',
    components: { EditorDashboard },
    data() {
      return {
        currentRole: 'EditorDashboard'
      }
    },
    computed: {
      ...mapGetters([
        'name',
        'avatar',
        'email',
        'introduction'
      ])
    }
    ,
   created() { //创建完成（可以访问当前this实例）
    // console.log(123456)
    },
  }
</script>



// WEBPACK FOOTER //
// src/views/dashboard/index.vue